export { Extauth2ChangePasswordStatus } from './generated/Extauth2ChangePasswordStatus.js';